/*******************************************
 * Slider Stuff *
 * We are using slickslider to handle all sliders *
 *******************************************/

jQuery(document).ready(function($) {

  $('.projects').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    slidesToShow: 1,
    centermode: false,
    infinite: true,
    draggable: true,
    cssEase: 'linear',
    variableWidth: true,
    touchThreshold: 100,
     adaptiveHeight: false,
    //centerMode: true,
    focusOnSelect: false,
    dots: true,
    prevArrow: $('.proj-prev-arrow'),
    nextArrow: $('.proj-next-arrow'),
    responsive: [
    {
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
              adaptiveHeight: true,
            //slidesToScroll: 3,
            //infinite: true,
            //dots: true
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
              adaptiveHeight: false,
            //slidesToScroll: 2
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
              adaptiveHeight: false,
            //slidesToScroll: 1
        }
    }
  ]
  });

  $(window).on('resize orientationchange', function() {
    $('.projects').slick('resize');
  });

  var Clock = {
      totalSeconds: 10,

      start: function () {
          var self = this;
            this.interval = setInterval(function () {
                self.totalSeconds -= 1;
                var counter = parseInt(self.totalSeconds);
                if (self.totalSeconds >= 0) {
                  $('#slider-timer').val(counter);
                  //console.log(counter);
                } else {
                  clearInterval(this.interval);
                  self.totalSeconds = 9;
                }
            
            }, 1000);
        },

        pause: function () {
            clearInterval(this.interval);
            delete this.interval;
        },

        resume: function () {
            if (!this.interval) this.start();
        },

        reset: function () {
            clearInterval(this.interval);
            delete this.interval;
            this.totalSeconds = 9;
            if (!this.interval) this.start();
           // if (!this.interval) this.start();
          //  this.start();
        },
    };


  $('.hero-slider').on('init', function(event, slick){
     Clock.start();

  });

  $('.hero-slider').slick({
    autoplay: true,
    autoplaySpeed: 10000,
    speed: 300,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    focusOnSelect: false,
    slidesToShow: 1,
    centermode: false,
    infinite: true,
    draggable: false,
    cssEase: 'linear',
    dots: true,
    arrows: false,
        responsive: [
        {
            breakpoint: 768,
            settings: {
                  draggable: true,
            }
        },
        {
            breakpoint: 480,
            settings: {
                  draggable: true,
            }
        }
      ]
  });

  $('.hero-slider').on('beforeChange swipe', function(event, slick, direction){
      Clock.reset();
      $(this).slick("slickSetOption", "autoplaySpeed", "9000");
  });

  $('.hero-slider').on( 'touchend touchcancel touchmove', function() { 
      $(this).slick('slickPlay');
      Clock.pause(); 
      var timerReset =  $('#slider-timer').val() * 1000;
      //console.log(timerReset);
      $(this).slick("slickSetOption", "autoplaySpeed", timerReset);
      Clock.resume();
  });

 


  if ($(window).width() >= 768) {
    $('.hero-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      const next = $(this).find('.slick-slide[data-slick-index="' + nextSlide + '"] video')[0];
      // play next video from the beginning
      next.currentTime = 0;
      next.play();
    });
  }

  $(window).on('resize orientationchange', function() {
    if ($(window).width() >= 768) {
      $('.hero-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const next = $(this).find('.slick-slide[data-slick-index="' + nextSlide + '"] video')[0];
        // play next video from the beginning
        next.currentTime = 0;
        next.play();
      });
    }
  });


  $(window).on('resize orientationchange', function() {
    $('.hero-slider').slick('resize');
  });

  
  $('.slide-wrap').slick({
    autoplay: true,
    autoplaySpeed: 25000,
    speed: 300,
    pauseOnFocus: true,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    dots: true,
    infinite: true,
    centermode: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    adaptiveWidth: true
  });

  $('.slide-wrap').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    const current = $(this).find('.image-wrap[data-slick-index="' +currentSlide + '"] video')[0];
    const next = $(this).find('.image-wrap[data-slick-index="' + nextSlide + '"] video')[0];
    // pause current
    current.pause();
    current.currentTime = 0;

    // play next video from the beginning
    next.currentTime = 0;
    next.play();
  });


  $(window).on('resize orientationchange', function() {
    $('.slide-wrap').slick('resize');
  });

  $('.logo-wrap').slick({
        slidesToShow: 2,
        mobileFirst: true,
        arrows: false,
        dots: true,
        autoplay: false,
        autoplaySpeed: 2000,
        centermode: true,
        responsive: [
            {
              breakpoint: 768,
              settings: 'unslick'
            },
          ]
    });
    // Making sure the slider fires on when the window resizes
    $(window).on('resize orientationchange', function() {
        $('.logo-wrap').slick('resize');
      });

    $('.history-wrap').slick({
      
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.years',
      });
      $('.years').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.history-wrap',
        arrows: true,
        centerMode: false,
        focusOnSelect: true,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    //slidesToScroll: 3,
                    //infinite: true,
                    //dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    //slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    //slidesToScroll: 1
                }
            }
        ]
      });
      $(window).on('resize orientationchange', function() {
        $('.history-wrap, .years').slick('resize');
      });

      $('.gallery').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 300,
        pauseOnFocus: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
       // slidesToShow: 1,
        centermode: false,
        infinite: true,
        draggable: true,
        cssEase: 'linear',
        variableWidth: true,
        adaptiveHeight: false,
        touchThreshold: 100,
        //centerMode: true,
        focusOnSelect: true,
        dots: true,
        prevArrow: $('.gal-prev-arrow'),
        nextArrow: $('.gal-next-arrow'),
        responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                //slidesToScroll: 3,
                //infinite: true,
                //dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                //slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                adaptiveHeight: true,
                //slidesToScroll: 1
            }
        }
      ]
      });

      $('.gallery').find()
      $(window).on('resize orientationchange', function() {
        $('.gallery').slick('resize');
      });

      //News Hero
      $('.news-hero-slider').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 300,
        pauseOnFocus: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow: 1,
        centermode: false,
        infinite: true,
        draggable: true,
        cssEase: 'linear',
        variableWidth: true,
        adaptiveHeight: false,
        touchThreshold: 100,
        //centerMode: true,
        focusOnSelect: true,
        dots: true,
        prevArrow: $('.news-prev-arrow'),
        nextArrow: $('.news-next-arrow'),
        responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                //slidesToScroll: 3,
                //infinite: true,
                //dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                //slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                //slidesToScroll: 1
            }
        }
      ]
      });
      $(window).on('resize orientationchange', function() {
        $('.news-hero-slider').slick('resize');
      });

     // had to add this year to detect actual doc height after slider inits
    
      var scrollTopBtn = $(".scrollToTopBtn");
      var bodyHeight = $('body').outerHeight();
      var windowHeight = $(window).height();
      var footerHeight = $('.site-footer').outerHeight(true);
      var footerStop = bodyHeight - windowHeight - footerHeight; 
      

      $(window).scroll(function() {

          if ($(this).scrollTop() > 100) {
            scrollTopBtn.addClass('showBtn');
          } else {
            scrollTopBtn.removeClass('showBtn');
          }
      });

    
      $(window).scroll(function() {
        if ($(this).scrollTop() > footerStop) {
            scrollTopBtn.addClass('footer-on');
        } else {
            scrollTopBtn.removeClass('footer-on');
        }
      });

      scrollTopBtn.click(function () {
        $("html, body").animate({scrollTop: 0}, 1000);
      });

      $(".slick-dots li").append('<svg height="20" width="20"><circle cx="10" cy="10" r="8" /></svg>');
      
});


